<template>
  <div>
    <b-message
      v-if="infoBannerDescription || isInfoBannerNotLastEledaVersion"
      type="is-warning"
      has-icon
      icon="exclamation-triangle"
      icon-size="is-small"
      class="m-0"
    >
      {{ infoBannerDescription ? infoBannerDescription : "" }}
      <br v-if="infoBannerDescription && isInfoBannerNotLastEledaVersion" />
      {{ isInfoBannerNotLastEledaVersion ? $t("Header.EMPTY_CACHE") : "" }}
    </b-message>

    <b-navbar>
      <template #brand>
        <div v-if="!isProductionServer" class="ribbon-wrapper">
          <div class="ribbon">{{ server }}<br />{{ "v." + eledaVersion }}</div>
        </div>

        <b-navbar-item
          v-if="isCurrentUserStudent"
          tag="router-link"
          :to="{ path: '/studentHome' }"
        >
          <img :src="logo" height="100%" />
        </b-navbar-item>
        <b-navbar-item v-else tag="router-link" :to="{ path: '/' }">
          <img :src="logo" height="100%" />
        </b-navbar-item>
      </template>
      <template #start>
        <b-navbar-item
          v-show="!isCurrentUserStudent"
          tag="router-link"
          :to="{ path: '/create' }"
        >
          <b-icon icon="pencil-ruler" size="is-medium" class="mr-1"></b-icon>
          {{ $t("Header.CREATE") }}
        </b-navbar-item>

        <b-navbar-dropdown
          v-show="!isCurrentUserStudent"
          arrowless
          :class="{ 'is-current-section': isSearchRouteActive }"
        >
          <template #label>
            <b-icon icon="globe-europe" size="is-medium" class="mr-1"></b-icon
            >{{ $t("Header.SEARCH") }}
          </template>
          <b-navbar-item
            aria-role="listitem"
            tag="router-link"
            :to="{ path: '/search/certified' }"
          >
            <span
              class="icon mr-1 svg-webkit-size-24"
              style="vertical-align: bottom"
            >
              <svg
                aria-hidden="true"
                focusable="false"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="-10 -10 384 384"
              >
                <path
                  d="M321.847,86.242l-40.026-23.11l-23.104-40.02h-46.213l-40.026-23.11l-40.026,23.11H86.239
		l-23.11,40.026L23.11,86.242v46.213L0,172.481l23.11,40.026v46.213l40.026,23.11l23.11,40.026h46.213l40.02,23.104l40.026-23.11
		h46.213l23.11-40.026l40.026-23.11v-46.213l23.11-40.026l-23.11-40.026V86.242H321.847z M156.911,243.075
		c-3.216,3.216-7.453,4.779-11.671,4.72c-4.219,0.06-8.455-1.504-11.671-4.72l-50.444-50.444c-6.319-6.319-6.319-16.57,0-22.889
		l13.354-13.354c6.319-6.319,16.57-6.319,22.889,0l25.872,25.872l80.344-80.35c6.319-6.319,16.57-6.319,22.889,0l13.354,13.354
		c6.319,6.319,6.319,16.57,0,22.889L156.911,243.075z"
                  class=""
                ></path>
              </svg>
            </span>
            {{ $t("Header.SEARCH_CERTIFIED") }}
          </b-navbar-item>
          <b-navbar-item
            aria-role="listitem"
            tag="router-link"
            :to="{ path: '/search/all' }"
          >
            <b-icon
              icon="globe-europe"
              class="mr-1"
              style="vertical-align: bottom"
            ></b-icon>
            {{ $t("Header.SEARCH_COMMUNITY") }}
          </b-navbar-item>
          <b-navbar-item
            v-if="isCurrentUserAuthenticated"
            aria-role="listitem"
            tag="router-link"
            :to="{ path: '/search/followed' }"
          >
            <b-icon
              icon="user-check"
              class="mr-1"
              style="vertical-align: bottom"
            ></b-icon>
            {{ $t("Header.FAVORITE_USERS") }}
          </b-navbar-item>
        </b-navbar-dropdown>

        <b-navbar-dropdown
          v-show="!isCurrentUserStudent"
          arrowless
          :class="{ 'is-current-section': isCollectionsRouteActive }"
        >
          <template #label>
            <b-icon icon="list-alt" size="is-medium" class="mr-1"></b-icon
            >{{ $t("Header.COLLECTIONS.TITLE") }}
          </template>
          <!-- Sous-menu -->
          <!-- Sous-menu avec classe personnalisée pour désactivation -->
          <!--   <b-navbar-item
              aria-role="listitem"
              tag="router-link"
              :to="{ path: '/sous-menu/item1' }"
              class="disabled-navbar-item"
            >
              Item 1 (Désactivé)
            </b-navbar-item>
             -->
          <b-navbar-item
            aria-role="listitem"
            tag="router-link"
            :to="{ path: '/collection/cp' }"
          >
            {{ $t("Header.COLLECTIONS.CP") }}
          </b-navbar-item>
          <b-navbar-item
            aria-role="listitem"
            tag="router-link"
            :to="{ path: '/collection/boulier' }"
          >
            Le boulier
          </b-navbar-item>
          <b-navbar-item
            aria-role="listitem"
            tag="router-link"
            :to="{ path: '/collection/ce1' }"
          >
            {{ $t("Header.COLLECTIONS.CE1") }}
          </b-navbar-item>
          <b-navbar-item
            aria-role="listitem"
            tag="router-link"
            :to="{ path: '/collection/ce2' }"
          >
            {{ $t("Header.COLLECTIONS.CE2") }}
          </b-navbar-item>
          <b-navbar-item
            aria-role="listitem"
            tag="router-link"
            :to="{ path: '/collection/cm1' }"
          >
            {{ $t("Header.COLLECTIONS.CM1") }}
          </b-navbar-item>
          <b-navbar-item
            aria-role="listitem"
            tag="router-link"
            :to="{ path: '/collection/cm2' }"
          >
            {{ $t("Header.COLLECTIONS.CM2") }}
          </b-navbar-item>
          <hr class="dropdown-divider" />

          <b-navbar-item
            aria-role="listitem"
            tag="router-link"
            :to="{ path: '/collection/brevet' }"
          >
            {{ $t("Header.COLLECTIONS.BREVET") }}
          </b-navbar-item>
          <b-navbar-item
            aria-role="listitem"
            tag="router-link"
            :to="{ path: '/collection/bacpro' }"
          >
            {{ $t("Header.COLLECTIONS.BACPRO") }}
          </b-navbar-item>
          <hr class="dropdown-divider" />

          <b-navbar-item
            aria-role="listitem"
            tag="router-link"
            :to="{ path: '/collection/universite' }"
          >
            {{ $t("Header.COLLECTIONS.UNIVERSITE") }}
          </b-navbar-item>
        </b-navbar-dropdown>

        <b-navbar-dropdown v-show="teams.length > 0" arrowless>
          <template #label>
            <b-icon icon="people-arrows" size="is-medium" class="mr-1"></b-icon
            >{{ $t("Header.MY_TEAMS") }}
          </template>
          <template v-if="isCurrentUserAuthenticated">
            <b-navbar-item
              aria-role="listitem"
              v-for="team in teams"
              :key="team.id"
              tag="router-link"
              :to="{ path: '/search/team/' + team.id }"
            >
              <b-icon
                icon="people-arrows"
                size="is-small"
                class="mr-1"
                style="vertical-align: bottom"
              ></b-icon>
              {{ team.name }}
              <!--</router-link>-->
            </b-navbar-item>
          </template>
        </b-navbar-dropdown>

        <b-navbar-dropdown
          v-show="!isCurrentUserStudent"
          arrowless
          :class="{ 'is-current-section': isHelpRouteActive }"
        >
          <template #label>
            <b-icon icon="book" size="is-medium" class="mr-1"></b-icon>
            {{ $t("Header.HELP") }}
          </template>
          <b-navbar-item tag="router-link" :to="{ path: '/tutorials' }">
            <b-icon icon="film" size="is-medium" class="mr-1"></b-icon>
            {{ $t("Header.TUTORIALS") }}
          </b-navbar-item>

          <b-navbar-item
            tag="router-link"
            :to="{ path: '/goodPractices' }"
            rel="noopener"
          >
            <b-icon icon="tasks" size="is-medium" class="mr-1"></b-icon>
            {{ $t("Header.GOODPRACTICES") }}
          </b-navbar-item>
          <b-navbar-item
            tag="router-link"
            :to="{ path: '/documentation' }"
            target="_blank"
            rel="noopener"
          >
            <b-icon icon="book-open" size="is-medium" class="mr-1"></b-icon>
            {{ $t("Header.DOCUMENTATION") }}
          </b-navbar-item>
          <!-- <b-navbar-item
            v-if="currentUser && !isCurrentUserGarTeacher"
            :href="getURLForum"
            target="_blank"
            rel="noopener"
          >
            <b-icon icon="comments" size="is-medium" class="mr-1"></b-icon>
            {{ $t("Header.FORUM") }}
          </b-navbar-item>

          <b-navbar-item
            v-else-if="!isCurrentUserStudent"
            :href="getURLForum"
            target="_blank"
            rel="noopener"
          >
            <b-icon icon="comments" size="is-medium" class="mr-1"></b-icon>
            {{ $t("Header.FORUM") }}
          </b-navbar-item>-->
        </b-navbar-dropdown>
      </template>

      <template #end>
        <b-navbar-item
          v-show="!isCurrentUserStudent"
          tag="router-link"
          :to="{ path: '/news' }"
        >
          <!--  <b-icon pack="fas" icon="bullhorn" size="is-small" class="mr-1"></b-icon>-->
          {{ $t("Header.NEWS") }}
          <b-tooltip
            v-if="isMaintenanceSoon"
            position="is-bottom"
            type="is-danger"
            multilined
          >
            <template v-slot:content>
              <span v-html="formatDate(dateStart, dateEnd)"></span>
            </template>
            <b-icon
              icon="exclamation-circle"
              type="is-danger"
              size="is-small"
              class="ml-1"
            ></b-icon>
          </b-tooltip>
          <b-tooltip
            v-else-if="isMaintenanceDoneRecently"
            position="is-bottom"
            type="is-success"
            multilined
          >
            <template v-slot:content>
              <span>
                {{ $t("Header.MAINTENANCE_DONE_RECENTLY") }} -
                {{ "v." + eledaVersion }}</span
              >
            </template>
            <b-icon
              icon="exclamation-circle"
              type="is-success"
              size="is-small"
              class="ml-1"
            ></b-icon>
          </b-tooltip>
        </b-navbar-item>
        <b-navbar-item
          v-if="!currentUser"
          tag="router-link"
          :to="{ path: '/pricing' }"
        >
          <!--  <b-icon icon="dollar-sign" size="is-small" class="mr-1"></b-icon>-->
          {{ $t("Header.PRICE") }}
        </b-navbar-item>

        <template v-if="!currentUser">
          <b-navbar-item>
            <b-button
              @click="isModalLoginActive = true"
              pack="fas"
              icon-left="sign-in-alt"
              tag="router-link"
              :to="{ path: '/login' }"
            >
              {{ $t("Header.SIGN_IN") }}
            </b-button>
          </b-navbar-item>
        </template>
        <template v-else>
          <b-navbar-dropdown
            id="profil"
            v-if="currentUser"
            right
            arrowless
            :class="{ 'is-current-section': isProfilRouteActive }"
          >
            <template #label>
              <avatar
                :size="32"
                color="#fff"
                :username="headerDisplayFullName"
              ></avatar>
              <span class="ml-1"> {{ headerDisplayName }}</span>
            </template>
            <b-navbar-item aria-role="menuitem">
              {{ $t("Header.LOGGED_AS") }}&nbsp;
              <b>{{ headerDisplayFullName }}</b>
              <b-tag class="ml-2" type="is-dark">{{ currentUserRole }}</b-tag>
            </b-navbar-item>
            <hr class="dropdown-divider" />
            <b-navbar-item
              v-show="!isCurrentUserStudent"
              aria-role="menuitem"
              tag="router-link"
              :to="{ path: '/myprofile' }"
            >
              <b-icon icon="user" class="mr-1"></b-icon>
              {{ $t("Header.PROFILE") }}
            </b-navbar-item>
            <b-navbar-item
              v-show="!isCurrentUserStudent"
              aria-role="menuitem"
              tag="router-link"
              :to="{ path: '/myactivities' }"
            >
              <b-icon icon="pencil-ruler" class="mr-1"></b-icon>
              {{ $t("Header.ACTIVITY") }}
            </b-navbar-item>
            <!--<b-navbar-item
            v-if="isCurrentUserAuthenticated"
            aria-role="listitem"
            tag="router-link"
            :to="{ path: '/search/favorites' }"
          >
            <b-icon
              icon="star"
              class="mr-1"
              style="vertical-align: bottom"
            ></b-icon>
            {{ $t("Header.FAVORITE_ACTIVITIES") }}
          </b-navbar-item>-->
            <b-navbar-item
              v-show="!isCurrentUserStudent"
              aria-role="menuitem"
              tag="router-link"
              :to="
                !checkPermission('sequence_get_own')
                  ? { path: '/sequencePreview' }
                  : { path: '/mysequences' }
              "
            >
              <span
                class="mr-1 icon image is-24x24 is-medium"
                style="vertical-align: bottom"
              >
                <img
                  :src="cartUrl"
                  alt="Sequence Icon"
                  class="image is-24x24"
                />
              </span>

              {{ $t("Header.SEQUENCES")
              }}<b-tag
                v-if="!checkPermission('sequence_get_own')"
                class="ml-2"
                type="is-dark"
                >Premium</b-tag
              >
            </b-navbar-item>

            <!--
            <b-navbar-item
              v-show="
                checkPermission('team_get_own') && !isCurrentUserGarTeacher
              "
              aria-role="menuitem"
              tag="router-link"
              :to="{ path: '/myTeams' }"
            >
              <b-icon icon="people-arrows" class="mr-1"></b-icon>
              {{ $t("Header.MY_TEAMS") }}
            </b-navbar-item>-->
            <hr
              class="dropdown-divider"
              v-show="!isCurrentUserStudent"
              aria-role="menuitem"
            />
            <b-navbar-item
              value="logout"
              aria-role="menuitem"
              @click="
                $router.push({
                  name: 'Logout',
                })
              "
            >
              <b-icon icon="sign-out-alt" class="mr-1"></b-icon>
              {{ $t("Header.SIGN_OUT") }}
            </b-navbar-item>
          </b-navbar-dropdown>
        </template>
        <b-navbar-dropdown
          v-show="!isCurrentUserStudent"
          right
          arrowless
          class="cart-icon pr-0"
          ref="dropdownCart"
        >
          <template #label>
            <span
              class="icon image is-32x32 is-medium"
              style="vertical-align: bottom"
            >
              <img
                :src="cartUrl"
                class="image is-32x32"
                alt="Sequence Cart Icon"
              />
            </span>
            <b-tag
              v-if="cartCount > 0"
              type="is-danger"
              rounded
              class="mr-0 mb-3"
              :class="{ 'is-animated': isAnimated }"
            >
              {{ cartCount }}
            </b-tag>
          </template>
          <Cart
            @openDropdownCart="openDropdownCart"
            @toBeNotCached="handleToBeNotCached"
          ></Cart>
        </b-navbar-dropdown>
        <b-navbar-item class="p-0" style="background: transparent">
          <LangSwitch />
        </b-navbar-item>

        <b-navbar-item v-if="checkPermission('menu_admin')">
          <b-dropdown aria-role="list" position="is-bottom-left">
            <template #trigger>
              <b-button pack="fas" icon-left="cogs" size="is-small" />
            </template>

            <b-dropdown-item has-link aria-role="menuitem">
              <router-link to="/adminActivities">
                {{ $t("Header.ADMIN.ACTIVITIES") }}</router-link
              >
            </b-dropdown-item>
            <b-dropdown-item has-link aria-role="menuitem">
              <router-link to="/adminSequences">
                {{ $t("Header.ADMIN.SEQUENCES") }}</router-link
              >
            </b-dropdown-item>
            <!--
            <b-dropdown-item has-link aria-role="menuitem">
              <router-link to="/adminSeances"> Seances</router-link>
            </b-dropdown-item>-->
            <b-dropdown-item has-link aria-role="menuitem">
              <router-link to="/adminUsers">
                {{ $t("Header.ADMIN.USERS") }}</router-link
              >
            </b-dropdown-item>
            <b-dropdown-item has-link aria-role="menuitem">
              <router-link to="/adminEstablishment">
                Établissements
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item has-link aria-role="menuitem">
              <router-link to="/adminTags">
                {{ $t("Header.ADMIN.TAGS") }}</router-link
              >
            </b-dropdown-item>
            <b-dropdown-item has-link aria-role="menuitem">
              <router-link to="/adminSponsors">
                {{ $t("Header.ADMIN.SPONSORS") }}</router-link
              >
            </b-dropdown-item>
            <b-dropdown-item has-link aria-role="menuitem">
              <router-link to="/adminCertifiedStamp">
                {{ $t("Header.ADMIN.CERTIFIEDSTAMP") }}</router-link
              >
            </b-dropdown-item>
            <b-dropdown-item has-link aria-role="menuitem">
              <router-link to="/adminComment">
                {{ $t("Header.ADMIN.COMMENT") }}</router-link
              >
            </b-dropdown-item>
            <b-dropdown-item has-link aria-role="menuitem">
              <router-link to="/adminRole">
                {{ $t("Header.ADMIN.ROLE") }}</router-link
              >
            </b-dropdown-item>
            <b-dropdown-item has-link aria-role="menuitem">
              <router-link to="/adminPermissions"> Permissions </router-link>
            </b-dropdown-item>

            <b-dropdown-item has-link aria-role="menuitem">
              <router-link to="/adminTeams"> Teams </router-link>
            </b-dropdown-item>
            <b-dropdown-item has-link aria-role="menuitem">
              <router-link to="/adminSearchBlock"> Search block </router-link>
            </b-dropdown-item>
            <b-dropdown-item has-link aria-role="menuitem">
              <router-link to="/adminGar"> GAR </router-link>
            </b-dropdown-item>
            <b-dropdown-item has-link aria-role="menuitem">
              <router-link to="/adminAcademieStats"> Statistiques </router-link>
            </b-dropdown-item>
          </b-dropdown>
        </b-navbar-item>
      </template></b-navbar
    >
  </div>
</template>

<script>
//CSS
import cartUrl from "@/assets/images/cart.svg";
import logo from "@/assets/images/eleda-logo.svg";
import Cart from "../components/Cart.vue";
import { mapGetters } from "vuex";

import LangSwitch from "../components/LangSwitch.vue";
import UtilsMixin from "../mixins/UtilsMixin.js";
import moment from "moment";
//import { PublicClientApplication } from "@azure/msal-browser";
import { server, frontendURL } from "../../src/config/settings-network.mjs";
import Avatar from "vue-avatar/src/Avatar.vue"; // raw SFC source, bypasses the package's Vue2-precompiled dist bundle
import UserDataService from "../services/UserDataService";
import TeamDataService from "../services/TeamDataService";

export default {
  name: "Header",
  mixins: [UtilsMixin],

  components: {
    LangSwitch,
    Cart,
    Avatar,
  },
  props: {
    title: {
      type: String,
      default: "Header",
    },
  },
  computed: {
    ...mapGetters(["cartCount"]),
    isSearchRouteActive() {
      return this.$route.path.startsWith("/search");
    },
    isCollectionsRouteActive() {
      return this.$route.path.startsWith("/collection");
    },
    isHelpRouteActive() {
      return (
        this.$route.path.startsWith("/tutorials") ||
        this.$route.path.startsWith("/goodPractices") ||
        this.$route.path.startsWith("/documentation")
      );
    },
    isProfilRouteActive() {
      return (
        this.$route.path.startsWith("/myprofile") ||
        this.$route.path.startsWith("/myactivities") ||
        this.$route.path.startsWith("/mysequences") ||
        this.$route.path.startsWith("/sequencePreview")
      );
    },
    // Name display (incl. the GAR "Ens. Lastname" privacy rule) is factored
    // in UtilsMixin's getDisplayNameForUser() so every view stays consistent.
    headerDisplayName() {
      return this.getDisplayNameForUser(this.currentUser, { compact: true });
    },
    headerDisplayFullName() {
      return this.getDisplayNameForUser(this.currentUser);
    },
  },
  data() {
    return {
      cartUrl,
      logo,
      server: server,
      isModalLoginActive: false,
      isLang: 1,
      preferredColor: "",
      preferredIcon: "",
      teams: [],
      hasTeams: false,

      maintenanceRelativeUrl: "/assets/localdata/maintenance.rss",
      infoBannerRelativeUrl: "/assets/localdata/infobanner.rss",

      infoBannerTitle: "",
      infoBannerDescription: "",
      isInfoBannerNotLastEledaVersion: false,

      frontendURL: frontendURL, //http(s) normal link
      maintenances: [],
      maintenance: {},
      dateStart: null,
      dateEnd: null,
      timeBeforeMaintenance: null,
      isMaintenanceSoon: false,
      isMaintenanceDoneRecently: false,
      isAnimated: false,
    };
  },

  mounted() {
    this.preferredColor = localStorage.getItem("preferredColor");
    this.preferredIcon = localStorage.getItem("preferredIcon");
    /*if (this.checkPermission("team_get_own")) {
         this.dbGetUserTeams();
    }*/
    this.getMaintenance();
    this.getInfoBanner();
  },

  async created() {
    /*this.$msalInstance = new PublicClientApplication(
      this.$store.state.msalConfig
    );*/
  },

  watch: {
    locale: function () {
      console.log("Change language into : ", this.languageShortCode);
    },
    cartCount(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.triggerAnimation();
      }
    },
    /*
    currentUser: function () {
      if (this.currentUser) {
        this.dbGetUserTeams();
      }
    },
    */
  },
  methods: {
    handleToBeNotCached(data) {
      this.$emit("toBeNotCached", data);
    },
    openDropdownCart() {
      console.log("openDropdownCart", this.$refs.dropdownCart);
      this.$refs.dropdownCart.showMenu();
      // this.$refs.dropdown.isActive = true;
      // this.isDropdownCartOpen = true;
      /*const dropdown = this.$refs.dropdownCart.$el;
      if (dropdown) {
        dropdown.classList.add("is-active");
      }*/
    },
    triggerAnimation() {
      this.isAnimated = true;
      setTimeout(() => {
        this.isAnimated = false;
      }, 300); // Durée de l'animation
    },

    async getInfoBanner() {
      const rssFile = await fetch(frontendURL + this.infoBannerRelativeUrl, {
        mode: "no-cors",
      });
      const infoBannerRSS = await rssFile.text();
      const feed = new window.DOMParser().parseFromString(
        infoBannerRSS,
        "text/xml"
      );
      const items = feed.querySelectorAll("item");
      this.infoBanners = [...items].map((el) => ({
        title: el.querySelector("title").innerHTML,
        description: el.querySelector("description").innerHTML,
        lastEledaVersion: el.querySelector("lastEledaVersion").innerHTML,
      }));

      this.infoBannerTitle = this.infoBanners[0]
        ? this.infoBanners[0].title
        : "";
      this.infoBannerDescription = this.infoBanners[0]
        ? this.infoBanners[0].description
        : "";
      console.log("this.infoBannerDescription", this.infoBannerDescription);
      this.isInfoBannerNotLastEledaVersion = this.infoBanners[0]
        ? this.infoBanners[0].lastEledaVersion != this.eledaVersion
        : false;
    },

    async getMaintenance() {
      const rssFile = await fetch(frontendURL + this.maintenanceRelativeUrl, {
        mode: "no-cors",
      });
      const maintenanceRSS = await rssFile.text();
      const feed = new window.DOMParser().parseFromString(
        maintenanceRSS,
        "text/xml"
      );
      const items = feed.querySelectorAll("item");
      this.maintenances = [...items].map((el) => ({
        title: el.querySelector("title").innerHTML,
        description: el.querySelector("description").innerHTML,
        comments: el.querySelector("comments").innerHTML,
      }));
      let maintenanceDescription = this.maintenances[0] || "";
      this.dateStart = this.maintenances
        ? maintenanceDescription.description
        : "";
      this.dateEnd = this.maintenances ? maintenanceDescription.comments : "";

      this.isMaintenanceSoon = this.isLessThan10Days(new Date(this.dateStart));
      this.isMaintenanceDoneRecently = this.isLessThan3DaysLater(
        new Date(this.dateStart)
      );
    },
    //check if the test date is less than 10 days from today
    isLessThan10Days(date) {
      const today = new Date();
      const diff = date - today;
      const diffInDays = diff / (1000 * 60 * 60 * 24);
      this.timeBeforeMaintenance = diffInDays;
      return 0 < diffInDays && diffInDays < 10;
    },

    //check if the test date is less than 2 days later from today
    isLessThan3DaysLater(date) {
      const today = new Date();
      const diff = today - date;
      const diffInDays = diff / (1000 * 60 * 60 * 24);
      this.timeAfterMaintenance = diffInDays;
      return 0 < diffInDays && diffInDays < 3;
    },

    formatDate(dateStart, dateEnd) {
      var dateStartMoment = moment(new Date(dateStart)).format(
        "dddd, Do MMMM YYYY, HH:mm"
      );
      var dateEndMoment = moment(new Date(dateEnd)).format(
        "dddd, Do MMMM YYYY, HH:mm"
      );
      //insecable white-space
      let returnStr =
        this.$t("Header.MAINTENANCE") +
        " " +
        dateStartMoment +
        "<br/>" +
        this.$t("Header.MAINTENANCE_END") +
        " " +
        "<br/>" +
        dateEndMoment +
        "<br/>(GMT Timezone)";
      return returnStr;
    },

    async SignOutMicrosoft() {
      console.log(localStorage.getItem("microsoft"));
      if (localStorage.getItem("microsoft") == "true") {
        await this.$msalInstance
          .logout({})
          .then(() => {
            this.$emitter.emit("logout", "logging out");
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        console.log("LogOut");
      }
    },
    dbGetUserTeams() {
      if (this.checkPermission("team_create")) {
        TeamDataService.getAllTeamsFromManager(this.currentUser.id)
          .then((response) => {
            this.teams = response.data;
          })
          .catch((e) => {
            console.log(e);
            this.showToast("Error when retrieving manager's team", "is-danger");
          });
      } else {
        UserDataService.getUserTeams(this.currentUser.id)
          .then((response) => {
            this.teams = response.data.teams;
          })
          .catch((e) => {
            console.log(e);
            this.showToast("Error when retrieving user's teams", "is-danger");
          });
      }
    },
  },
};
</script>

<style lang="scss">
// Highlights the current top-level nav section. Dropdown triggers (Explore activities,
// Collections, Help) get it via .is-current-section (bound to a route-matching computed
// property, since the dropdown label isn't itself a router-link). Plain links (Create) get
// it "for free" from Vue Router's own .router-link-active class on the same element.
.navbar-item.has-dropdown.is-current-section > .navbar-link,
.navbar-item.router-link-active {
  font-weight: bold;
  border-bottom: 3px solid hsl(0, 0%, 35%); // dark grey, kept subtle
}

// Sub-items inside an open dropdown (e.g. Profile menu) reuse the same
// .router-link-active class as top-level nav items - the bold weight alone
// is enough there, the 3px top-level border is too heavy on a menu item.
.navbar-dropdown .navbar-item.router-link-active {
  border-bottom: none;
}

.is-animated {
  animation: zoom 0.3s ease-in-out;
  z-index: 1000; /* S'assurer que le tag est au-dessus des autres éléments */
  position: relative; /* Nécessaire pour que z-index fonctionne */
}

@keyframes zoom {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3); /* Effet grossissant */
  }
  100% {
    transform: scale(1);
  }
}

.ribbon-wrapper {
  width: 85px;
  height: 88px;
  position: absolute;
  top: -3px;
  left: -3px;
  z-index: 7;
}
.ribbon-wrapper .ribbon {
  font: bold 15px sans-serif;
  color: #333;
  text-align: center;
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  position: relative;
  padding: 4px 0;
  top: 15px;
  left: -30px;
  width: 120px;
  background-color: rgb(255, 221, 87);
  color: #fff;
}

.media-content {
  margin-left: 15px;
}

#admin {
  margin-left: 15px;
}

#profil {
  /*margin-right: 15px;*/
}

/* Style personnalisé pour simuler la désactivation */
.disabled-navbar-item {
  font-style: italic; /* Ajout du style italic */
  pointer-events: none;
  opacity: 0.8; /* Vous pouvez ajuster l'opacité selon vos préférences */
  cursor: not-allowed;
}
</style>
